import React from 'react'
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from './PageAnimations';

const Contact =(props) => {

    return (
        <motion.div initial="out" animate="in" exit="out" variants={pageVariants} transition={pageTransition} >
            <h2>This is Contact Component</h2>
        </motion.div>
    )
}

export default Contact;
